import React from 'react';
import styled from 'styled-components';
import { Typography } from '@drone-js/core';

const HighlightTextStyled = styled(Typography)`
    display: inline;
`;

const HighlightText: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <HighlightTextStyled textColor="product.primary">{children}</HighlightTextStyled>;
};

HighlightText.displayName = 'HighlightText';
export { HighlightText };
